import React, { useEffect, useState } from "react";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import CustomButton from "../../components/form/CustomButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
    getPrefixes,
    clientsResource,
    plansResource,
    resetPassword
} from "../../helpers/configRoutes/backend_helper";
import CustomInput from "../../components/form/CustomInput";
import CustomSelect from "../../components/form/CustomSelect";
import { showFormErrors } from "../../helpers/showFormErrors";
import { validatePhones } from "../../helpers/forms/Validation";

const AddUpdClientModal = ({ modal, setModal, clientItem, setFilters, filters }) => {
    const [prefixes, setPrefixes] = useState([]);
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [resetLoading, setResetLoading] = useState(false);

    const baseitem = {
        id: null,
        name: "",
        active: "",
        address: "",
        dot: "",
        mc_number: "",
        contact_name: "",
        email: "",
        invoicing_address: "",
        phone: "",
        prefix_id: "",
        created_at: "",
        plan_name: "",
        status_name: "",
        plan_id: "",
        trial_mode: true,
        active: false
    };

    const validation = useFormik({
        initialValues: clientItem,
        validationSchema: Yup.object({
            email: Yup.string().email("Invalid email").required("Email is required"),
            name: Yup.string().required("Name is required"),
            prefix_id: Yup.string().required("Prefix is required"),
            phone: validatePhones(true),
            contact_name: Yup.string().required("Contact name is required"),
            address: Yup.string().required("Address is required"),
            invoicing_address: Yup.string().required("Invoicing address is required"),
            dot: Yup.string().required("DOT is required"),
            mc_number: Yup.string().required("MC number is required")
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);
            const response = await clientsResource(
                values.id ? "put" : "post",
                values,
                values.id
            );

            if (response.status) {
                setFilters({ ...filters, search: filters.search });
                setModal({ ...modal, show: false });
            } else {
                setErrors(response.errors || {});
            }
            setLoading(false);
        }
    });

    useEffect(() => {
        if (clientItem?.id) {
            validation.setValues(clientItem);
        } else {
            validation.resetForm({ values: baseitem });
        }
    }, [modal]);

    useEffect(() => {
        const loadCatalogs = async () => {
            const plansRes = await plansResource("get", { params: { select: true } });
            setPlans(plansRes.plans || []);

            const prefixRes = await getPrefixes();
            if (prefixRes.status) setPrefixes(prefixRes.prefixes);
        };
        loadCatalogs();
    }, []);

    const handleSendResetPassword = async () => {
        if (!validation.values?.email) {
            validation.setFieldTouched("email", true);
            validation.setFieldError("email", "Email is required to send the reset link");
            return;
        }

        setResetLoading(true);
        await resetPassword({ email: validation.values.email, reset: true });
        setResetLoading(false);
    };

    return (
        <BaseModalAnimated modal={modal} setModal={setModal}>
            <form
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                }}
                className=""
            >

                {/* Company */}
                <section className="rounded-2xl bg-cs-surface border border-cs-border p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <CustomInput
                            label="Company Name"
                            name="name"
                            error={validation.errors?.name}
                            value={validation.values?.name}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />
                        <CustomInput
                            label="Contact Name"
                            name="contact_name"
                            error={validation.errors?.contact_name}
                            value={validation.values?.contact_name}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">


                        <CustomInput
                            label="Email Address"
                            name="email"
                            error={validation.errors?.email}
                            value={validation.values?.email}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />

                        
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <CustomSelect
                                    label="Phone Prefix"
                                    options={prefixes}
                                    name="prefix_id"
                                    error={validation.errors?.prefix_id}
                                    value={validation.values?.prefix_id}
                                    handleChange={validation.handleChange}
                                    labelClassName="text-sm text-cs-muted"
                                />

                                <div className="">
                                    <CustomInput
                                        label="Phone Number"
                                        name="phone"
                                        error={validation.errors?.phone}
                                        value={validation.values?.phone}
                                        handleChange={validation.handleChange}
                                        labelClassName="text-sm text-cs-muted"
                                    />
                                </div>
                            </div>
                        
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <CustomInput
                            label="Address"
                            name="address"
                            error={validation.errors?.address}
                            value={validation.values?.address}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />

                        <CustomInput
                            label="Invoicing Address"
                            name="invoicing_address"
                            error={validation.errors?.invoicing_address}
                            value={validation.values?.invoicing_address}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />
                    </div>
                </section>

                {/* Legal */}
                <section className="rounded-2xl bg-cs-surface border border-cs-border p-2">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <CustomInput
                            label="DOT"
                            name="dot"
                            type="number"
                            error={validation.errors?.dot}
                            value={validation.values?.dot}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />

                        <CustomInput
                            label="MC Number"
                            name="mc_number"
                            type="number"
                            error={validation.errors?.mc_number}
                            value={validation.values?.mc_number}
                            handleChange={validation.handleChange}
                            labelClassName="text-sm text-cs-muted"
                        />
                    </div>
                </section>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                    <CustomSelect
                        label="Subscription Type"
                        options={plans}
                        name="plan_id"
                        error={validation.errors?.plan_id}
                        value={validation.values?.plan_id}
                        handleChange={validation.handleChange}
                        labelClassName="text-sm text-cs-muted"
                    />

                    {/* Botón Trial Mode */}
                    <button
                        type="button"
                        onClick={() =>
                            validation.setFieldValue("trial_mode", !validation.values?.trial_mode)
                        }
                        className={`px-4 py-2 rounded-full font-semibold text-sm transition-colors
                                        ${validation.values?.trial_mode
                                ? "bg-cs-primary text-white hover:bg-cs-primary-hover"
                                : "bg-cs-surface-alt text-cs-muted hover:bg-cs-bg-alt"
                            }`}
                    >
                        {validation.values?.trial_mode ? "Trial Mode ON" : "Trial Mode OFF"}
                    </button>
                </div>
                {/* Footer */}
                <div className="flex justify-between gap-3 border-t border-cs-border px-6 py-4">

                    <div>
                        {validation.values?.id && (
                            <CustomButton
                                type="secondary"
                                loading={resetLoading}
                                textLoad="Sending"
                                className="px-6"
                                onClick={handleSendResetPassword}
                            >
                                Send password reset
                            </CustomButton>
                        )}
                    </div>

                    <CustomButton
                        loading={loading}
                        textLoad="Saving"
                        type="success"
                        className="bg-cs-primary hover:bg-cs-primary-hover text-white px-10"
                    >
                        {validation.values?.id ? "Save Changes" : "Add New Client"}
                    </CustomButton>
                </div>
            </form>
        </BaseModalAnimated>
    );
};

export default AddUpdClientModal;
